var app = require('../app')

app.controller('SidebarSitesController', function ($scope, $localStorage) {
  $scope.$storage = $localStorage
})
